import { render } from "./AdminHomePage.vue?vue&type=template&id=dc451112"
import script from "./AdminHomePage.vue?vue&type=script&lang=js"
export * from "./AdminHomePage.vue?vue&type=script&lang=js"

import "./AdminHomePage.vue?vue&type=style&index=0&id=dc451112&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__